import React, { useState, useEffect } from 'react'
import { Container, Grow, Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import * as actionType from '../../constants/actionTypes'
import { getPosts } from '../../actions/posts'
import Rooms from '../../components/Rooms/Rooms'
import RoomsHeading from '../../components/Rooms/RoomsHeading/RoomsHeading'
import FloatingButton from '../../components/FloatingButton/FloatingButton'
import useStyles from './styles.js'

const Home = () => {
  const [currentId, setCurrentId] = useState(0)
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getPosts())
  }, [currentId, dispatch])

  const login = () => {
    dispatch({ type: actionType.AUTH })

    history.push('/login')
  }

  return (
    <Grow in>
      <Container maxWidth='lg'>
        <Grid
          className={classes.gridContainer}
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
        >
          <Grid item xs={12} sm={7} md={9} style={{ marginTop: '20px' }}>
            <RoomsHeading categories='📚Study Rooms' />
          </Grid>

          <Rooms
            roomsCategory='Study'
            currentId={currentId}
            setCurrentId={setCurrentId}
          />
          <Grid item xs={12} sm={7} md={9} style={{ marginTop: '20px' }}>
            <RoomsHeading categories='👨‍🚀Work Rooms' />
          </Grid>

          <Rooms
            roomsCategory='Work'
            currentId={currentId}
            setCurrentId={setCurrentId}
          />

          <Grid item xs={12} sm={7} md={9} style={{ marginTop: '20px' }}>
            <RoomsHeading categories='💤Sleep Rooms' />
          </Grid>

          <Rooms
            roomsCategory='Sleep'
            currentId={currentId}
            setCurrentId={setCurrentId}
          />

          <Grid item xs={12} sm={7} md={9} style={{ marginTop: '20px' }}>
            <RoomsHeading categories='📺Watching Rooms' />
          </Grid>

          <Rooms
            roomsCategory='Watching'
            currentId={currentId}
            setCurrentId={setCurrentId}
          />

          <Grid item xs={12} sm={7} md={9} style={{ marginTop: '20px' }}>
            <RoomsHeading categories='🎧Listening Rooms' />
          </Grid>
        </Grid>

        <FloatingButton
          login={login}
          currentId={currentId}
          setCurrentId={setCurrentId}
        />
      </Container>
    </Grow>
  )
}

export default Home
